export default class MultiCheckbox {
    valueInputElement: HTMLInputElement;
    fieldsetElement: HTMLFieldSetElement;
    checkboxItems: HTMLInputElement[];
    selectedValues: string[] = [];

    constructor(private inputId: string) {
        this.valueInputElement = document.getElementById(this.inputId) as HTMLInputElement;
        if (!this.valueInputElement) return;
        this.fieldsetElement = document.getElementById(`${this.inputId}-checkbox-group`) as HTMLFieldSetElement;
       
        this.initElements();
        this.selectedValues = this.checkboxItems.filter(checkbox => checkbox.checked).map(checkbox => checkbox.value);
    }

    private initElements() {
        this.checkboxItems = Array.from(this.fieldsetElement.querySelectorAll('.ktc-checkbox input[type="checkbox"]'));
        this.checkboxItems.forEach(checkbox => checkbox.addEventListener('change', (e) => this.onChangeInput(e)));
    }

    private onChangeInput(e: Event) {
        e.preventDefault();
        e.stopPropagation();
        const target = e.target as HTMLInputElement;

        if (this.selectedValues.includes(target.value)) {
            this.selectedValues = this.selectedValues.filter(value => value !== target.value);
        } else {
            this.selectedValues.push(target.value);
        }

        this.valueInputElement.value = this.selectedValues.join(";");
        this.valueInputElement.dispatchEvent(new Event('change'));
    }
}
